/**
 * Gets the component's display name
 * @param Component React component definition
 */
export function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
